class LanguageConstant {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

// 语言代码映射
export const LANG_CODE_MAP = {
  'zh': 'zh_CN',
  'en': 'en_US',
  'jp': 'ja_JP',
  'ru': 'ru_RU',
  'vi': 'vi_VN',
  'th': 'th_TH'
}

export const LANG_NAME_MAP = {
  'zh': '中文',
  'en': 'English',
  'jp': '日本語',
  'ru': 'Русский',
  'vi': 'Tiếng Việt',
  'th': 'ไทย',
  'zh_CN': '中文',
  'en_US': 'English',
  'ja_JP': '日本語',
  'ru_RU': 'Русский',
  'vi_VN': 'Tiếng Việt',
  'th_TH': 'ไทย'
}

export const ZH_CN = new LanguageConstant('zh_CN', '中文', 'Chinese')
export const EN_US = new LanguageConstant('en_US', '英文', 'English')
export const JA_JP = new LanguageConstant('ja_JP', '日文', 'Japanese')
export const RU_RU = new LanguageConstant('ru_RU', '俄文', 'Russian')
export const VI_VN = new LanguageConstant('vi_VN', '越南文', 'Vietnamese')
export const TH_TH = new LanguageConstant('th_TH', '泰文', 'Thai')

/**
 * 语言合集
 */
export const LANGUAGE_SET = new Set([ZH_CN, EN_US, JA_JP, RU_RU, VI_VN, TH_TH])

export function getLanguageByCode(code) {
  for (const item of LANGUAGE_SET) {
    if (item.code === code) {
      return item
    }
  }
  return null
}
